import { motion } from "framer-motion";

const easing = [0.22, 0.61, 0.36, 1];

const Reveal = ({
  as = "div",
  delay = 0,
  y = 26,
  once = true,
  className,
  children,
  ...rest
}) => {
  const Component = motion[as] || motion.div;

  return (
    <Component
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-40px 0px" }}
      transition={{ duration: 0.65, delay, ease: easing }}
      {...rest}
    >
      {children}
    </Component>
  );
};

export default Reveal;
